// Shortcut hints show the platform's modifier glyph: ⌘ on Apple, ⌃ (Control) elsewhere.
export const modifierKeySymbol = /Mac|iPod|iPhone|iPad/.test(navigator.platform) ? '⌘' : '⌃'
